import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link as RouteLink } from 'react-router-dom';
import {
  Toolbar, Breadcrumbs,Paper, Container,
  Dialog, DialogActions, DialogContent, DialogTitle, Button, Menu, 
  ListItemIcon, Link, DialogContentText, Hidden, IconButton,

  Box, MenuItem, 
  Grid, Typography, Card, CardContent, CardActionArea, TextField,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { red, lightGreen, deepPurple, grey } from '@mui/material/colors';

import MoreHoriz from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { format } from 'date-fns';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    // MuiChip-root
    tagStyle: {
      '&.MuiChip-root': {
        marginLeft: theme.spacing(1),
        height: '20px',
        fontSize: '0.75rem',
        color: '#fff',
        '&.tagPurple': {
          backgroundColor: deepPurple[200],
        },
        '&.tagRed': {
          backgroundColor: red['A100'],
        },
        '&.tagGreen': {
          backgroundColor: lightGreen[300],
        },

      },
    },
    cardTitle: {
      fontWeight: 'bold',
      '& em': {
        color: theme.palette.primary.main
      }
    },
    cardText: {
      color: grey,
      fontSize: '.5rem',
      '& em': {
        color: theme.palette.primary.main
      }
    },
    selectRoot: {
      width: '110px',
      margin: '0 12px',
    }
  })
);

export interface DocumentGridItem {
  id: string;
  thumbnail: string;
  type: 'folder' | 'file',
  url: string;
  name: string;
  link: string;
  updatedAt: string;
}
interface DocumentProps {
  document: DocumentGridItem;
  isWarning: boolean;
  onMenuClick?: (e, id) => void;
  onClick?: (e, id: string) => void;
}
export function SearchDocumentGridList(props: DocumentProps) {
  const { 
    root, document, type,
    isWarning, onMenuClick, onClick 
  } = props;
  // const { id, thumbnail, name, link, updatedAt } = document;

  const classes = useStyles();

  const handleOnMenuClick = (e) => {
    // onMenuClick(e, id);
  };
  const handleClick = (e) => {
    // onClick?.(e, id);
    window.open(e);
  };
  const [thumbnailSrc, setThumbnailSrc] = useState('/fileTypes/genericfile.svg');
  useEffect(() => {
    const thum = _.get(document, ['thumbnail'], '');
    if (_.isEmpty(thum)) {
      type === 'folder' ? setThumbnailSrc('/fileTypes/folder.svg') : setThumbnailSrc('/fileTypes/genericfile.svg');
    } else {
      setThumbnailSrc(thum);
    }
  }, [document]);
  
  return (
    <Card elevation={0} >
      <CardActionArea 
        // component={RouteLink} 
        // to={`${root}/${document.doc_id}`}
        onClick={() => handleClick(`/${root}/${document.doc_id}`)} 
      >
        <CardContent
          style={{
            display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
            padding: '8px 0', borderBottom: '1px solid #F6F6F6'
          }}
        >
          <img src={thumbnailSrc} style={{ height: '30px', width: '30px', marginLeft: '12px', marginRight: '12px' }} />
          <Box display='flex' flexDirection='column' >
            <span
              className={classes.cardTitle}
              style={{width:'100%', overflow:'auto'}} 
              dangerouslySetInnerHTML={{__html:document?.resourcename}}
            />
            {!_.isEmpty(_.get(document, ['content'], '')) && <span
              className={classes.cardText}
              style={{width:'100%', overflow:'auto'}} 
              dangerouslySetInnerHTML={{__html:document?.content}}
            />}
          </Box>
          {/* menu按钮 暂时屏蔽 */}
          {/* {!isWarning && <IconButton onClick={handleOnMenuClick}>
            <MoreHoriz />
          </IconButton>} */}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default function SearchPage(props) {
  const { root, data, isWarning, handleMenuClick, onOpen } = props;

  const [t] = useTranslation();
  const classes = useStyles();
  // id+cover.jpg是对应的图片信息
  const [totalResult, setTotalResult] = useState(0);  // 搜索结果
  const [doc, setDoc] = useState([]);
  const [folder, setFolder] = useState([]);
  const [highlighting, setHighLighting] = useState([]);
  const [count, setCount] = useState({
    count_doc: 0,
    count_folder: 0,
    count_highlight: 0,
    count_total: 0,
  });
  // total folder doc highlight
  const [selectResult, setSelectResult] = useState('total');

  useEffect(() => {
    const data_doc = _.get(data, ['doc'], []);
    const data_folder = _.get(data, ['folder'], []);
    const data_heghlighting = _.get(data, ['highlighting'], []);
    const newCount = {
      count_doc: data_doc.length,
      count_folder: data_folder.length,
      count_highlight: data_heghlighting.length,
      count_total: data_doc.length + data_folder.length + data_heghlighting.length,
    };
    setDoc(data_doc);
    setFolder(data_folder);
    setHighLighting(data_heghlighting);
    setCount(newCount);
  }, [data]);


  return ( 
    <Grid container direction="row" spacing={1}>
      {/* 搜索  注释 */}
      {/* {serachData.map(item => <Grid key={item.id} */}
      <Box display='flex' margin='12px 0'>
        <Typography variant='h6'>共 {count.count_total} 条 搜索结果</Typography>
        <TextField 
          id='selectResult' 
          className={classes.selectRoot}
          value={selectResult} 
          select
          onChange={(e) => {
            setSelectResult(e.target.value);
          }}
        >
          <MenuItem value='total'>所有结果</MenuItem>
          <MenuItem value='folder'>文件夹</MenuItem>
          <MenuItem value='doc'>文件</MenuItem>
          <MenuItem value='highlight'>正文</MenuItem>
        </TextField>
      </Box>
     
      {/* {data.map(item => <Grid key={item.id}
        item xs={12} sm={12} md={12}
      > */}
      {/* mockData folder  highlighting */}
      {(selectResult === 'total' || selectResult === 'folder') && folder.map(item => <Grid key={item.doc_id}
        item xs={12} sm={12} md={12} 
      >
        <SearchDocumentGridList
          type='folder'
          root={root}
          document={item}
          // highlighting={data['highlighting']}
          isWarning={isWarning} 
          onMenuClick={handleMenuClick} 
          onClick={onOpen} 
        />
      </Grid>)}
      {(selectResult === 'total' || selectResult === 'doc') && doc.map(item => <Grid key={item.doc_id}
        item xs={12} sm={12} md={12} 
      >
        <SearchDocumentGridList
          type='doc'
          root={root}
          document={item}
          // highlighting={data['highlighting']}
          isWarning={isWarning} 
          onMenuClick={handleMenuClick} 
          onClick={onOpen} 
        />
      </Grid>)}
      {(selectResult === 'total' || selectResult === 'highlight') && highlighting.map(item => <Grid key={item.doc_id}
        item xs={12} sm={12} md={12} 
      >
        <SearchDocumentGridList
          type='doc'
          root={root}
          document={item}
          // highlighting={data['highlighting']}
          isWarning={isWarning} 
          onMenuClick={handleMenuClick} 
          onClick={onOpen} 
        />
      </Grid>)}
    </Grid>
  );
}